module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-index default-content-container",
    class: {
      landscape: _vm.isLandscape, 'portrait': _vm.isPortrait, mobile: _vm.isMobile
    }
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Henning Maier-Jantzen "), _c('em', [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-8 text-column"
  }, _vm._l((_vm.clients), function(category, index) {
    return _c('div', {
      staticClass: "margin-bottom-large"
    }, [_c('h3', [_vm._v(_vm._s(category.name[_vm.lang]))]), _vm._v(" "), _c('p', _vm._l((category.clients), function(c, cindex) {
      return _c('span', [((!c.link || c.nolink) && !c.url) ? _c('span', [_vm._v(_vm._s(c.name))]) : _vm._e(), _vm._v(" "), (c.link && !c.nolink) ? _c('a', {
        class: {
          bold: c.link
        },
        on: {
          "click": function($event) {
            _vm.openLink(c)
          }
        }
      }, [_vm._v(_vm._s(c.name))]) : _vm._e(), _vm._v(" "), (c.url && !c.link) ? _c('a', {
        staticClass: "bold",
        attrs: {
          "href": c.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(c.name))]) : _vm._e(), _vm._v(" "), (cindex < category.clients.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
    }), 0)])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18234b1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients.vue
// module id = 182
// module chunks = 2